export const shadows = [
    'none',
    '-1px 4px 8px rgba(233, 233, 244, 100%);',
    '-1px 8px 16px rgba(170, 170, 186, 45%);',
    '0px -2px 24px rgba(103, 103, 121, 50%);',
    '0px -2px 24px rgba(103, 103, 121, 50%);',
    '0px -2px 24px rgba(103, 103, 121, 50%);',
    '0px -2px 24px rgba(103, 103, 121, 50%);',
    '0px -2px 24px rgba(103, 103, 121, 50%);',
    '0px -2px 24px rgba(103, 103, 121, 50%);',
    '0px -2px 24px rgba(103, 103, 121, 50%);',
    '0px -2px 24px rgba(103, 103, 121, 50%);',
    '0px -2px 24px rgba(103, 103, 121, 50%);',
    '0px -2px 24px rgba(103, 103, 121, 50%);',
    '0px -2px 24px rgba(103, 103, 121, 50%);',
    '0px -2px 24px rgba(103, 103, 121, 50%);',
    '0px -2px 24px rgba(103, 103, 121, 50%);',
    '0px -2px 24px rgba(103, 103, 121, 50%);',
    '0px -2px 24px rgba(103, 103, 121, 50%);',
    '0px -2px 24px rgba(103, 103, 121, 50%);',
    '0px -2px 24px rgba(103, 103, 121, 50%);',
    '0px -2px 24px rgba(103, 103, 121, 50%);',
    '0px -2px 24px rgba(103, 103, 121, 50%);',
    '0px -2px 24px rgba(103, 103, 121, 50%);',
    '0px -2px 24px rgba(103, 103, 121, 50%);',
    '0px -2px 24px rgba(103, 103, 121, 50%);',
];
